import {LitElement, css, html} from 'lit';
import {customElement, property, state} from 'lit/decorators.js';
import {ContextConsumer} from '@lit/context';
import {artistContext } from '../context/artist-context.ts';

@customElement('artist-view')
export class ArtistView extends LitElement {

  @state()
  private view?: string = 'grid'

  @property()
  timetable:boolean = false;

  private _onViewChange(view:string) {
    const options = {
      detail: view,
      bubbles: true,
      composed: true
    };
    this.dispatchEvent(new CustomEvent('artistViewChange', options));
    sessionStorage.setItem('pvListView', view)
  }

  connectedCallback() {
    super.connectedCallback()
    new ContextConsumer(this, {
      context: artistContext,
      subscribe: true,
      callback: ({view}) => {
        if (view) {
          this.view = view
          this.requestUpdate();
        }
      },
    });
    let sessionListView = sessionStorage.getItem('pvListView')
    if (sessionListView) {
      this._onViewChange(sessionListView)
    }
    if(window.location.hash && window.location.hash.substring(1) === 'timetable') {
      this._onViewChange(window.location.hash.substring(1))
    }
  }
  createRenderRoot() {
    return this;
  }
  render() {
    return html`
        
        <button class=${this.view === 'grid' ? 'active' : ''} @click="${() => this._onViewChange('grid')}" aria-label="Grid-view">
            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 100 100" width="16" height="16" style="enable-background:new 0 0 100 100;" xml:space="preserve">
                <path d="M38.5,45H6.5C2.9,45,0,42.1,0,38.5V6.5C0,2.9,2.9,0,6.5,0h32.1C42.1,0,45,2.9,45,6.5v32.1C45,42.1,42.1,45,38.5,45z"/>
                <path d="M93.5,45H61.5c-3.6,0-6.5-2.9-6.5-6.5V6.5C55,2.9,57.9,0,61.5,0h32.1c3.6,0,6.5,2.9,6.5,6.5v32.1C100,42.1,97.1,45,93.5,45z  "/>
                <path d="M38.5,100H6.5C2.9,100,0,97.1,0,93.5V61.5C0,57.9,2.9,55,6.5,55h32.1c3.6,0,6.5,2.9,6.5,6.5v32.1C45,97.1,42.1,100,38.5,100  z"/>
                <path d="M93.5,100H61.5c-3.6,0-6.5-2.9-6.5-6.5V61.5c0-3.6,2.9-6.5,6.5-6.5h32.1c3.6,0,6.5,2.9,6.5,6.5v32.1  C100,97.1,97.1,100,93.5,100z"/>
            </svg>
        </button>
        <button class=${this.view === 'list' ? 'active' : ''} @click="${() => this._onViewChange('list')}" aria-label="List-view">
            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 100 100" width="16" height="16" style="enable-background:new 0 0 100 100;" xml:space="preserve">
                <path d="M93.5,45H6.5C2.9,45,0,42.1,0,38.5V6.5C0,2.9,2.9,0,6.5,0h87.1c3.6,0,6.5,2.9,6.5,6.5v32.1C100,42.1,97.1,45,93.5,45z"/>
                <path d="M93.5,100H6.5C2.9,100,0,97.1,0,93.5V61.5C0,57.9,2.9,55,6.5,55h87.1c3.6,0,6.5,2.9,6.5,6.5v32.1  C100,97.1,97.1,100,93.5,100z"/>
            </svg>
        </button>
        
        ${this.timetable
          ? html`
            <button class=${this.view === 'timetable' ? 'active' : ''} @click="${() => this._onViewChange('timetable')}" aria-label="Timetable-view">
                Timetable
            </button>
            `
          : null
        }
        
    `}

  static styles = css`
      :host {
      }
  `;
}

declare global {
  interface HTMLElementTagNameMap {
    'artist-view': ArtistView
  }
}
